<template>
  <MainHeader />
  <MainSidebar />
  <div
    class="main-content bg_gray d-flex flex-column transition overflow-hidden"
  >
    <BreadcrumbMenu pageTitle="Product Report" />
    <div class="row gx-lg-0 mb-15">
      <div class="col-lg-9">
        <div class="filter-left d-flex align-items-center flex-wrap row">
          <div class="col-md-4">
            <form action="#" class="search-area position-relative w-100 mb-15">
              <input
                type="search"
                placeholder="Search On This Table"
                class="w-100 h-55 bg_ash border-0 rounded-1 fs-14 text-black bg-white"
              />
              <button
                type="submit"
                class="bg-transparent border-0 position-absolute top-0 end-0 h-100 pt-0 py-0 px-2"
              >
                <img src="../../assets/img/icons/search.svg" alt="Image" />
              </button>
            </form>
          </div>
          <div class="col-md-4">
            <div class="form-group mb-15">
              <select class="bg-white fs-14 border-0 rounded-1">
                <option value="1">Warehouse 01</option>
                <option value="2">Warehouse 02</option>
                <option value="3">Warehouse 03</option>
              </select>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group mb-15">
              <input type="date" class="bg-white fs-14 border-0 rounded-1" />
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-3">
        <div
          class="filter-right d-flex align-items-center justify-content-lg-end flex-wrap w-100 ms-0"
        >
          <a href="#" class="btn style-three">Excel</a>
          <a href="#" class="btn style-four">Pdf</a>
        </div>
      </div>
    </div>
    <ProductReport />

    <div class="flex-grow-1"></div>
    <MainFooter />
  </div>

  <div
    class="delete-popup offcanvas offcanvas-end border-0"
    tabindex="-1"
    id="deletePopup"
  >
    <div class="offcanvas-body p-0">
      <div class="delete-success">
        <img src="../../assets/img/icons/tick-circle.svg" alt="Image" />
        <span class="text-white fw-medium">
          Your product is deleted from the list.
        </span>
      </div>
    </div>
  </div>
  <ProductDetailsReportModal />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import MainHeader from "../../components/Layouts/MainHeader.vue";
import MainSidebar from "../../components/Layouts/MainSidebar.vue";
import BreadcrumbMenu from "../../components/Common/BreadcrumbMenu.vue";
import ProductReport from "../../components/Reports/ProductReport/ProductReport.vue";
import ProductDetailsReportModal from "../../components/Reports/ProductReport/ProductDetailsReportModal.vue";
import MainFooter from "../../components/Layouts/MainFooter.vue";

export default defineComponent({
  name: "ProductReportPage",
  components: {
    MainHeader,
    MainSidebar,
    BreadcrumbMenu,
    ProductReport,
    ProductDetailsReportModal,
    MainFooter,
  },
});
</script>

<style lang="scss" scoped>
.filter-left {
  button {
    margin-right: 10px;
  }
  .search-area {
    input {
      padding-left: 20px;
      &::placeholder {
        opacity: 0.8;
      }
    }
  }
}
.filter-right {
  a {
    margin-right: 10px;
    &:last-child {
      margin-right: 0;
    }
  }
  div,
  button {
    margin-right: 10px;
  }
}

@media only screen and (max-width: 767px) {
  .filter-left {
    .btn {
      margin-bottom: 15px;
    }
  }
  .filter-right {
    a,
    div,
    button {
      margin-bottom: 10px;
    }
  }
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .filter-right {
    width: calc(100% + 20px);
    margin-left: -20px;
  }
}

@media only screen and (max-width: 991px) {
  .filter-left {
    margin-bottom: 20px;
  }
}

@media only screen and (min-width: 992px) {
  .filter-left {
    .search-area {
      width: 320px;
    }
  }
}

@media only screen and (min-width: 1400px) {
  .filter-left {
    button {
      margin-right: 15px;
    }
    .search-area {
      width: 320px;
    }
  }
  .filter-right {
    a,
    div,
    button {
      margin-right: 15px;
    }
  }
}
</style>